// extracted by mini-css-extract-plugin
export default {"window":"wO8yZT","close-button":"G8OHH3","closeButton":"G8OHH3","content":"v2Ivt7"};